import React, { useContext, useEffect, useState } from "react";
import "./PD_SectionOne.scss";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getProductsDetails } from "../../../services/productsDetails/productsDetails";
import { Button, Col, Row, Tooltip, message } from "antd";
import { FaRuler } from "react-icons/fa6";
import { FaTag } from "react-icons/fa";
import { AiOutlineSafetyCertificate, AiOutlineGlobal } from "react-icons/ai";
import { LiaShippingFastSolid } from "react-icons/lia";
import { IoBag } from "react-icons/io5";
import { TiStarFullOutline } from "react-icons/ti";
import { PiHeartFill } from "react-icons/pi";
import Tab_Products from "../../../components/Tab_Products";
import Modal_No_Login from "../../../components/Modal_No_Login";
import Modal_Offers from "../../../components/Modal_Offers";
import { getCookie } from "../../../helper/cookie";
import { priceNew } from "../../../helper/priceNew";
import { formatNumber } from "../../../helper/fomartNum";
import { UserContext } from "../../../context/userContext";
import { patchUserLike, patchUserCart } from "../../../services/user/user";
import PF_SectionOne from "../../ProductsFull/PF_SectionOne";

function PD_SectionOne() {
  const [productsDetails, setProductsDetails] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const params = useParams();
  const token = getCookie("token");
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  // Kiểm tra đăng nhập
  const handleCheckLogin = (callback) => {
    if (!token) {
      setIsLoginModalOpen(true);
      return;
    }
    callback && callback();
  };

  // Thích / bỏ thích sản phẩm
  const handleActiveLove = async (product) => {
    handleCheckLogin(async () => {
      if (!currentUser) return;
      const isLiked = currentUser.liked?.includes(product.id);
      const newLiked = isLiked
        ? currentUser.liked.filter((id) => id !== product.id)
        : [...currentUser.liked, product.id];
      await patchUserLike(currentUser.id, newLiked);
      setCurrentUser({ ...currentUser, liked: newLiked });
    });
  };

  const isProductLiked = (product) => currentUser?.liked?.includes(product.id);

  // Thêm vào giỏ hàng
  const handleAddCart = async (product) => {
    handleCheckLogin(async () => {
      if (!currentUser) return;
      const newCart = currentUser.cart
        ? [...currentUser.cart, product.id]
        : [product.id];
      await patchUserCart(currentUser.id, newCart);
      setCurrentUser({ ...currentUser, cart: newCart });
      messageApi.success("Đã thêm vào giỏ hàng!");
    });
  };

  // Click "Mua ngay"
  const handleBuyNow = (product) => {
    handleCheckLogin(() => {
      navigate("/checkout", { state: { buyNowProduct: product } });
    });
  };

  // Lấy chi tiết sản phẩm
  useEffect(() => {
    const fetchApi = async () => {
      const content = await getProductsDetails(params.id);
      setProductsDetails(content);
      if (content.length > 0) setMainImage(content[0].thumbnail1);
    };
    fetchApi();
  }, [params.id]);

  const handleThumbnailClick = (img) => setMainImage(img);

  return (
    <>
      {contextHolder}
      <div className="pd-sectionOne">
        <div className="container">
          {productsDetails.length > 0 &&
            productsDetails.map((item) => (
              <div key={item.id} className="pd-sectionOne-wrapper">
                <Row gutter={[44, 44]}>
                  <Col xxl={10} xl={10}>
                    <div className="pd-sectionOne-content-left">
                      <img src={mainImage} alt="Main" className="main-image" />
                      <Row gutter={[8, 8]} className="thumbnails">
                        {[
                          item.thumbnail1,
                          item.thumbnail2,
                          item.thumbnail3,
                        ].map((thumb, index) => (
                          <Col key={index} xs={8}>
                            <img
                              src={thumb}
                              alt={`Thumbnail ${index + 1}`}
                              onClick={() => handleThumbnailClick(thumb)}
                              className={mainImage === thumb ? "active" : ""}
                            />
                          </Col>
                        ))}
                      </Row>
                      <Tooltip title="Thích">
                        <div
                          onClick={() => handleActiveLove(item)}
                          className={`iconLove ${
                            isProductLiked(item) ? "active" : ""
                          }`}
                        >
                          <PiHeartFill />
                        </div>
                      </Tooltip>
                    </div>
                  </Col>

                  <Col xxl={14} xl={14}>
                    <div className="pd-section-right">
                      <div className="bag">
                        <IoBag className="bag-icon" />
                        <div className="bag-info">{item.bag}</div>
                      </div>

                      <div className="title">{item.title}</div>

                      <div className="info">
                        <div className="size">
                          <div className="size-icon">
                            <FaRuler className="icon" />
                            <div className="size-name">Size:</div>
                          </div>
                          <div className="size-info">{item.size}</div>
                        </div>

                        <div className="condition">
                          <div className="condition-icon">
                            <FaTag className="icon" />
                            <div className="condition-name">Tình trạng:</div>
                          </div>
                          <div>{item.condition}</div>
                        </div>

                        <div className="brands">
                          <div className="brands-icon">
                            <AiOutlineGlobal className="icon" />
                            <div className="brands-name">Brand:</div>
                          </div>
                          <div>{item.name}</div>
                        </div>
                      </div>

                      <div className="price">
                        <div className="price_new">
                          {formatNumber(priceNew(item.price_old, item.sales))}
                          <span className="underline">đ</span>
                        </div>
                        <del className="price_old">
                          {formatNumber(item.price_old)}
                          <span className="underline">đ</span>
                        </del>
                        <div className="sales">-{item.sales}%</div>
                      </div>

                      <Button
                        className="btn-buy"
                        onClick={() => {
                          handleCheckLogin(() => {
                            navigate("/checkoutNow", {
                              state: { buyNowProduct: item },
                            });
                          });
                        }}
                      >
                        Mua ngay
                      </Button>

                      <div className="btn-add">
                        <Button
                          className="btn-addOffer"
                          onClick={() =>
                            handleCheckLogin(() => setIsOfferModalOpen(true))
                          }
                        >
                          Đề nghị giá mới
                        </Button>

                        <Button
                          className="btn-addCart"
                          onClick={() => handleAddCart(item)}
                        >
                          Thêm vào giỏ hàng
                        </Button>
                      </div>

                      <div className="safe">
                        <AiOutlineSafetyCertificate className="safe-icon" />
                        <div>
                          Mọi giao dịch mua hàng thông qua Depop đều được bảo vệ
                          bởi Chính sách Bảo vệ Người mua.
                        </div>
                      </div>

                      <div className="time">
                        <LiaShippingFastSolid className="time-icon" />
                        <div>
                          Người bán này thường giao hàng trong vòng{" "}
                          <b>24 giờ</b>
                        </div>
                      </div>

                      <div className="shop">
                        <div className="img">
                          <img src={item.avtshop} alt="Avatar Shop" />
                        </div>
                        <div className="info-shop">
                          <div className="info-name">{item.name_shop}</div>
                          <div className="info-icon">
                            <TiStarFullOutline />
                            <TiStarFullOutline />
                            <TiStarFullOutline />
                            <TiStarFullOutline />
                            <TiStarFullOutline />
                          </div>
                          <div className="info-status-sold">
                            <div className="sold">
                              Đã bán: <b>{item.sold}</b>
                            </div>
                            <div className="status">{item.status}</div>
                          </div>
                        </div>
                      </div>

                      <Link>
                        <Button className="btn-seeShop">Xem shop</Button>
                      </Link>

                      {/* COMMENTS */}
                      <div className="comments">
                        <div className="comments-title">Đánh giá gần đây</div>
                        {item.comment.map((c) => (
                          <div key={c.id} className="comments-user">
                            <div className="comments-user-common">
                              <div className="comments-star">
                                <TiStarFullOutline />
                                <TiStarFullOutline />
                                <TiStarFullOutline />
                                <TiStarFullOutline />
                                <TiStarFullOutline />
                              </div>
                              <div className="comments-name">bởi {c.name}</div>
                              <div className="comments-time">{c.time}</div>
                            </div>
                            <div className="comments-user-img">
                              <div className="img">
                                <img src={c.img} alt="Image Products cmt" />
                              </div>
                              <div className="des">{c.details}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Tab_Products productsDetails={productsDetails} />

                <div className="pd-sectionOne-products-else">
                  Những sản phẩm khác
                </div>

                <PF_SectionOne />

                <Modal_No_Login
                  isModalOpen={isLoginModalOpen}
                  handleCancel={() => setIsLoginModalOpen(false)}
                />

                <Modal_Offers
                  isModalOpen={isOfferModalOpen}
                  handleCancel={() => setIsOfferModalOpen(false)}
                  productsDetails={productsDetails}
                  userByToken={currentUser}
                />
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default PD_SectionOne;
